import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { translate } from 'services/i18nService';
import { generateID } from 'utils/helpers';

import icra from '../../../../../images/footer/icra.png';
import labeled from '../../../../../images/footer/labeled.gif';
import rta from '../../../../../images/footer/rta_b.png';

import styles from './index.css';


const makeId = generateID('ssdq12FB', 'disclaimerWithAgeVerification');

const IDS = {
  icra: makeId('badge-icra'),
  rtab: makeId('badge-rta_b'),
  labeled: makeId('badge-labeled'),
};

export default class BadgeSection extends PureComponent {
  static propTypes = { className: PropTypes.string };

  static defaultProps = { className: undefined };

  render() {
    const { className } = this.props;

    return (
      <div className={classNames(styles.container, className)}>
        <p>{translate('disclaimer.disclaimer.text1.capitalized')}</p>
        <div className={styles.badgeContainer}>
          <img
            alt="icra"
            className={styles.badge}
            height={25}
            id={IDS.icra}
            src={icra}
            width={63}
          />
          <img
            alt="rta_b"
            className={styles.badge}
            height={25}
            id={IDS.rtab}
            src={rta}
            width={67}
          />
          <img
            alt="labeled"
            className={styles.badge}
            height={25}
            id={IDS.labeled}
            src={labeled}
            width={66}
          />
        </div>
      </div>
    );
  }
}
